import React from "react";
import Button from "react-bootstrap/Button";
import ButtonWithPopover from "components/ButtonWithPopover";

const DiscardRaw = ({ onDiscard, disabled, elementIdPrefix = "switchdisposition" }) => {
  return (
    <ButtonWithPopover
      placement="top"
      customRef={`${elementIdPrefix}-discard`}
      buttonVariant="danger"
      buttonText="Discard"
      buttonIsBlock={true}
      buttonIsDisabled={disabled}
      popoverTitle="Discard Response"
      buttonId={`${elementIdPrefix}-btn-discard`}
    >
      <p className="confirmation-text">
        Do you want to <b>discard</b> this response? It will leave the RAW list
        and will not be dispositioned.
      </p>
      <div className="align-content-right">
        <Button
          id={`${elementIdPrefix}-btn-discard-confirm`}
          className="left-spacer"
          variant="danger"
          onClick={onDiscard}
          disabled={disabled}
        >
          Discard
        </Button>
      </div>
    </ButtonWithPopover>
  );
};

export default DiscardRaw;
